import { render, staticRenderFns } from "./Main.Dropdown.Menu.vue?vue&type=template&id=57068f98&scoped=true&"
import script from "./Main.Dropdown.Menu.vue?vue&type=script&lang=js&"
export * from "./Main.Dropdown.Menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57068f98",
  null
  
)

export default component.exports